import {useField, useFormikContext} from 'formik';
import React from 'react';
import {hasKey} from '../../../utils/getters';
import {Container, InputField, InputContainer} from './styles';
import CustomCountryFlag from '../../atoms/CustomCountryFlag';
import {theme} from '../../../styles/darkTheme';
import Input from 'react-phone-number-input/input';
import ErrorMessage from '../FormField/ErrorMessage';

interface Props {
  placeholder: string;
  name: string;
  disabled: boolean;
  value?: string;
}

const PhoneField: React.FC<Props> = ({
  placeholder,
  name,
  disabled = false,
  value,
}) => {
  const {errors, touched, setFieldValue} = useFormikContext();
  const [field] = useField(name);

  const getError = () => {
    if (hasKey(errors, name)) {
      // @ts-ignore
      return errors[name];
    }
    return null;
  };

  const getTouched = () => {
    if (hasKey(touched, name)) {
      // @ts-ignore
      return touched[name];
    }
    return false;
  };

  return (
    <Container>
      <InputContainer>
        <CustomCountryFlag theme={theme} />
        <Input
          country="US" //To be changed
          placeholder={placeholder}
          inputComponent={InputField}
          value={value || field.value}
          onChange={value => setFieldValue(field.name, value)}
          disabled={disabled}
        />
      </InputContainer>
      <ErrorMessage error={getError()} visible={getTouched()} />
    </Container>
  );
};

export default PhoneField;
